import { quickNews } from "@/mocks/news";

export default function NewsTicker() {
  const items = [...quickNews, ...quickNews];

  return (
    <div className="bg-foreground-950 text-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 h-10 flex items-center gap-3 overflow-hidden">
        <span className="shrink-0 inline-flex items-center gap-1.5 px-2.5 py-1 rounded bg-accent-500 text-foreground-950 text-xs font-medium font-label">
          <i className="ri-flashlight-fill"></i>
          快讯播报
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="ticker-track">
            {items.map((item, index) => (
              <span
                key={`${item.time}-${index}`}
                className="inline-flex items-center gap-2 text-xs md:text-[13px] text-background-200 font-label pr-10 whitespace-nowrap"
              >
                <span className="text-accent-400 tabular-nums">{item.time}</span>
                {item.text}
                <i className="ri-flashlight-line text-background-500"></i>
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}